import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SpaTubIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SpaTubIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M22.3275 9.26217C22.0035 9.26217 21.7401 9.52544 21.7401 9.85017V11.5026C21.7401 12.2206 21.1575 12.8043 20.442 12.8043C19.7257 12.8043 19.1431 12.2206 19.1431 11.5026C19.1431 11.178 18.8805 10.9147 18.5565 10.9147C18.2318 10.9147 17.9692 11.178 17.9692 11.5026C17.9692 12.2206 17.3866 12.8043 16.6703 12.8043C15.9548 12.8043 15.3721 12.2206 15.3721 11.5026C15.3721 11.178 15.1088 10.9147 14.7848 10.9147C14.4609 10.9147 14.1975 11.178 14.1975 11.5026C14.1975 12.2206 13.6149 12.8043 12.8994 12.8043C12.1831 12.8043 11.6005 12.2206 11.6005 11.5026C11.6005 11.178 11.3379 10.9147 11.0131 10.9147C10.6892 10.9147 10.4266 11.178 10.4266 11.5026C10.4266 12.2206 9.84396 12.8043 9.12769 12.8043C8.4122 12.8043 7.82955 12.2206 7.82955 11.5026C7.82955 11.178 7.56618 10.9147 7.24223 10.9147C6.9175 10.9147 6.65491 11.178 6.65491 11.5026C6.65491 12.2206 6.07226 12.8043 5.35677 12.8043C4.6405 12.8043 4.05785 12.2206 4.05785 11.5026V8.84083H7.24146C7.56619 8.84083 7.82878 8.57754 7.82878 8.25283C7.82878 7.92812 7.56619 7.66482 7.24146 7.66482H4.05863V4.95642C4.05863 4.6317 3.79604 4.36841 3.47131 4.36841C3.14736 4.36841 2.88477 4.6317 2.88477 4.95642V18.3783C2.88477 19.4585 3.76185 20.3371 4.83939 20.3371H20.9602C22.0377 20.3371 22.9148 19.4585 22.9148 18.3783V9.85017C22.9148 9.52544 22.6522 9.26217 22.3275 9.26217ZM20.9602 19.1612H4.83934C4.40894 19.1612 4.05858 18.8103 4.05858 18.3783V13.6105C4.43613 13.8449 4.88128 13.9802 5.3575 13.9802C6.11185 13.9802 6.7885 13.6395 7.24297 13.1039C7.69665 13.6399 8.37331 13.9802 9.12844 13.9802C9.88357 13.9802 10.5602 13.6395 11.0139 13.1039C11.4684 13.6399 12.145 13.9802 12.9001 13.9802C13.6552 13.9802 14.3311 13.6395 14.7856 13.1039C15.2393 13.6399 15.916 13.9802 16.6711 13.9802C17.4262 13.9802 18.1029 13.6395 18.5573 13.1039C19.011 13.6399 19.6877 13.9802 20.4428 13.9802C20.9182 13.9802 21.3634 13.8449 21.7409 13.6105V18.3783C21.7409 18.8099 21.3906 19.1612 20.9602 19.1612Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.4216 8.71718C17.2802 9.00942 17.403 9.36112 17.6943 9.50277C17.7766 9.54262 17.8644 9.56181 17.9498 9.56181C18.1682 9.56181 18.3771 9.43975 18.4789 9.23006C18.9171 8.32361 18.7943 7.22976 18.1666 6.44302C17.8116 5.99898 17.7487 5.38438 18.0066 4.87775C18.1534 4.58825 18.0384 4.2342 17.7494 4.08671C17.4604 3.93961 17.1062 4.05463 16.9593 4.34413C16.4932 5.26154 16.6067 6.37377 17.2491 7.17772C17.5956 7.61236 17.6632 8.21641 17.4216 8.71718Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.2769 8.71717C14.1355 9.00941 14.2574 9.36112 14.5488 9.5027C14.6319 9.54263 14.7189 9.56182 14.8044 9.56182C15.0227 9.56182 15.2324 9.43975 15.3334 9.23006C15.7723 8.32361 15.6488 7.22976 15.0211 6.44302C14.6661 5.99898 14.6032 5.38438 14.8611 4.87775C15.0079 4.58825 14.8929 4.2342 14.6039 4.08671C14.3149 3.93961 13.9615 4.05463 13.8139 4.34413C13.3477 5.26154 13.4611 6.37377 14.1036 7.17773C14.4501 7.61238 14.5192 8.21641 14.2769 8.71717Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.158 8.71718C11.0166 9.00942 11.1386 9.36112 11.4306 9.50277C11.513 9.54262 11.6 9.56181 11.6855 9.56181C11.9038 9.56181 12.1135 9.43975 12.2145 9.23006C12.6534 8.32361 12.5307 7.22976 11.9022 6.44302C11.5472 5.99898 11.485 5.38438 11.7422 4.87775C11.889 4.58825 11.774 4.2342 11.485 4.08671C11.196 3.93961 10.8426 4.05463 10.695 4.34413C10.2288 5.26154 10.343 6.37377 10.9848 7.17772C11.332 7.61236 11.4004 8.21641 11.158 8.71718Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SpaTubIcon;
